<template>
  <v-dialog v-model="dialog" width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        text
        color="primary"
        x-small
        @click="dialog = true"
        class="mx-2"
        >Resolve</v-btn
      >
    </template>

    <v-card>
      <validation-observer v-slot="{ invalid }">
        <v-card-title>Resolve Transmittal Error</v-card-title>
        <v-card-text class="text--center">
          <label>Reason / Comments:</label>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-textarea
              v-model="message"
              auto-grow
              rows="2"
              outlined
              :error-messages="errors"
            ></v-textarea>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading"
            :disabled="loading"
            text
            @click="clear"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            :dark="!invalid && !loading"
            :disabled="invalid || loading"
            :loading="loading"
            @click="resolve"
          >
            Resolve
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["transmittalId"],
  data() {
    return {
      dialog: false,
      loading: false,
      message: "",
    };
  },
  methods: {
    async resolve() {
      this.$store.commit("uxModule/setShowLoader", true);
      var message = await this.$store.dispatch(
        "transmittalsModule/resolveTransmittal",
        { transmittalId: this.transmittalId, message: this.message }
      );
      this.$store.commit("uxModule/setShowLoader", false);

      if (message) {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          `Error Resolving Transmittal: ${message}`
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.clear();
    },
    clear() {
      this.message = "";
      this.dialog = false;
    },
  },
};
</script>
